module.exports = __webpack_public_path__ + "static/media/wall11.92a99738.jpeg";